import ImportTaskButton from "./components/templates/ImportTaskButton.vue";

export default {
    install (app) {
        app.component('ImportTaskButton', ImportTaskButton)
    }
}